export default () => ({
  namespaced: true,
  state: {
    error: null,
    response: null
  },

  mutations: {
    setError (state, error) {
      state.response = error && error.response
      state.error = error
    }
  }
})
